import { GET_PRODUCT_DETAILS_BY_ID_SUCCESS } from '../actionTypes/ProductCompareActionTypes';
import aboveGridConfig from '../containers/Pages/ProductCompare/AboveGridConfig';

const analyticsConfig = {
    productPPID: null,
    productLotId: [null],
    productSKU: null,
    productName: null,
    productListPrice: null,
    productCurrentSellingPrice: null,
    productMarketingLabel: null,
    productStoreAvailability: null,
    productPricingCadence: null,
    productInStock: null,
    productDeliveryMethod: null,
    productSurchargePrice: null,
    productAverageRating: null,
    productReviews: null,
    productGiftRegistryIndicator: null,
    productEcoRebatesFlag: null,
};

/* istanbul ignore next */
export default function productCompareReducer(state = {}, action) {
    // NOSONAR
    /* eslint-disable no-case-declarations */
    switch (action.type) {
        case GET_PRODUCT_DETAILS_BY_ID_SUCCESS:
            const gridKeys = {};
            const gridData = {};
            const aboveGridData = {};
            const ppIds = [];
            const analyticsObj = [];
            const productsCategory = {
                categoryName: '',
                items: 0,
            };
            const sourceData = action.payload.data ? action.payload.data : [];

            const fetchKeysAsMap = (attributes) => {
                const localMap = {};
                attributes.forEach((key) => {
                    if (!localMap[key.name]) {
                        localMap[key.name] = null;
                    }
                });
                return localMap;
            };

            const prepareGridKeys = () => {
                sourceData.forEach((section) => {
                    const gridSection = section.defaultLotSpecification.data;
                    gridSection.forEach((category) => {
                        if (!gridKeys[category.name]) {
                            gridKeys[category.name] = fetchKeysAsMap(category.attributes);
                        } else {
                            gridKeys[category.name] = Object.assign(
                                gridKeys[category.name],
                                fetchKeysAsMap(category.attributes)
                            );
                        }
                    });
                });
            };

            const reconcileCategory = (concileKeys, category, level) => {
                const keys = Object.keys(concileKeys);
                keys.forEach((k) => {
                    if (!category[k]) {
                        // Category field might be missing in the source
                        const concilation = [];
                        concilation[level] = null;
                        /* eslint no-param-reassign: ["error", { "props": false }] */
                        category[k] = concilation;
                    }
                    if (category[k][level] === undefined) {
                        // Category field value might be missing in the source
                        /* eslint no-param-reassign: ["error", { "props": false }] */
                        category[k][level] = null;
                    }
                });
            };

            const prepareAboveGridData = (key) => {
                try {
                    aboveGridConfig.forEach((configKey) => {
                        switch (configKey.name) {
                            case 'image':
                                if (!aboveGridData[configKey.name]) {
                                    aboveGridData[configKey.name] = [key.images[0].url];
                                } else {
                                    aboveGridData[configKey.name].push(key.images[0].url);
                                }
                                break;

                            case 'title':
                                if (!aboveGridData[configKey.name]) {
                                    aboveGridData[configKey.name] = [key.name];
                                } else {
                                    aboveGridData[configKey.name].push(key.name);
                                }
                                break;

                            case 'productPageLink':
                                if (!aboveGridData[configKey.name]) {
                                    aboveGridData[configKey.name] = [key.ppUrl];
                                } else {
                                    aboveGridData[configKey.name].push(key.ppUrl);
                                }
                                break;

                            case 'ratings':
                                if (!aboveGridData[configKey.name]) {
                                    aboveGridData[configKey.name] = [
                                        {
                                            rating: key.valuation.rating,
                                            count:
                                                key.valuation.reviews && key.valuation.reviews.count
                                                    ? key.valuation.reviews.count
                                                    : null,
                                        },
                                    ];
                                } else {
                                    aboveGridData[configKey.name].push({
                                        rating: key.valuation.rating,
                                        count:
                                            key.valuation.reviews && key.valuation.reviews.count
                                                ? key.valuation.reviews.count
                                                : null,
                                    });
                                }
                                break;

                            case 'modelNumber':
                                if (!aboveGridData[configKey.name]) {
                                    aboveGridData[configKey.name] = [key.lots[0].modelNumber];
                                } else {
                                    aboveGridData[configKey.name].push(key.lots[0].modelNumber);
                                }
                                break;

                            case 'price': //eslint-disable-line
                                const priceRoot = key.pricing.root;
                                const price = { priceRoot };

                                if (!aboveGridData[configKey.name]) {
                                    aboveGridData[configKey.name] = [price];
                                } else {
                                    aboveGridData[configKey.name].push(price);
                                }
                                break;

                            case 'color': //eslint-disable-line
                                let lotInd;
                                let color = null;
                                let noOfColors = null;
                                let colorNode = null;
                                for (let ind = 0; ind < key.lots.length; ind += 1) {
                                    if (key.lots[ind].isDefault) {
                                        lotInd = ind;
                                        break;
                                    }
                                }
                                if (key.dimensions) {
                                    color = key.dimensions[0].options[lotInd].value;
                                    noOfColors = key.dimensions[0].options.length - 1;
                                }
                                colorNode = { color, noOfColors };

                                if (!aboveGridData[configKey.name]) {
                                    aboveGridData[configKey.name] = [colorNode];
                                } else {
                                    aboveGridData[configKey.name].push(colorNode);
                                }
                                break;

                            default:
                                break;
                        }
                    });
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.log('error in parsing data', e);
                } finally {
                    // eslint-disable-next-line no-console
                    console.log('TODO:: handle non - error + plus error cases here');
                }
            };

            const prepareAnalyticsObj = (productData) => {
                try {
                    const tempObj = { productInfo: {} };
                    const infoObj = tempObj.productInfo;
                    const keys = Object.keys(analyticsConfig);
                    let defaultLot = null;
                    const lots = [];
                    let priceRoot;

                    if (productData.lots instanceof Array) {
                        for (let i = 0; i < productData.lots.length; i += 1) {
                            if (
                                productData.lots[i].isDefault &&
                                productData.lots[i].isDefault === true
                            ) {
                                defaultLot = productData.lots[i];
                            }
                            lots.push(productData.lots[i].id);
                        }
                    }

                    if (productData.pricing && productData.pricing.root) {
                        const { root } = productData.pricing;
                        if (root.amounts && root.amounts.length) {
                            priceRoot = root.amounts;
                        }
                    }

                    keys.map((key) => { //eslint-disable-line
                        switch (key) {
                            case 'productPPID':
                                infoObj[key] = productData.id;
                                break;

                            case 'productLotId':
                                infoObj[key] = lots;
                                break;

                            case 'productSKU':
                                infoObj[key] =
                                    (defaultLot && defaultLot.items && defaultLot.items[0].id) ||
                                    '';
                                break;

                            case 'productName':
                                infoObj[key] = (productData.name || '').toLowerCase();
                                break;

                            case 'productCurrentSellingPrice':
                                if (priceRoot && priceRoot.length >= 1) {
                                    infoObj[key] = `${priceRoot[1].max || ''}`;
                                } else {
                                    infoObj[key] = '';
                                }
                                break;

                            case 'productListPrice':
                                if (priceRoot && priceRoot.length > 0) {
                                    infoObj[key] = `${priceRoot[0].max || ''}`;
                                } else {
                                    infoObj[key] = '';
                                }
                                break;

                            case 'productSurchargePrice':
                                infoObj[key] =
                                    (defaultLot &&
                                        defaultLot.surcharges &&
                                        `${defaultLot.surcharges.amount || ''}`) ||
                                    '';
                                break;

                            case 'productStoreAvailability':
                                infoObj[key] = (defaultLot && defaultLot.channelOffering) || '';
                                break;

                            case 'productPricingCadence':
                                if (priceRoot && priceRoot.length >= 1) {
                                    infoObj[key] = (priceRoot[1].type || '').toLowerCase();
                                } else {
                                    infoObj[key] = '';
                                }
                                break;

                            case 'productAverageRating':
                                if (productData && productData.valuation) {
                                    infoObj[key] = `${productData.valuation.rating || ''}`;
                                } else {
                                    infoObj[key] = '';
                                }
                                break;

                            case 'productReviews':
                                infoObj[key] =
                                    productData &&
                                    productData.valuation &&
                                    productData.valuation.reviews &&
                                    productData.valuation.reviews.count
                                        ? `${productData.valuation.reviews.count}`
                                        : '';
                                break;

                            case 'productMarketingLabel':
                                if (productData.pricing && productData.pricing.root) {
                                    infoObj[key] = (
                                        productData.pricing.root.marketingLabel || ''
                                    ).toLowerCase();
                                } else {
                                    infoObj[key] = '';
                                }
                                break;

                            case 'productGiftRegistryIndicator':
                                infoObj[key] =
                                    defaultLot &&
                                    defaultLot.tags &&
                                    defaultLot.tags.indexOf('gift-registry') !== -1
                                        ? 'yes'
                                        : 'no';
                                break;

                            case 'productDeliveryMethod':
                                infoObj[key] =
                                    defaultLot &&
                                    defaultLot.shipping &&
                                    defaultLot.shipping.shipFromFactory
                                        ? 'yes'
                                        : 'no';
                                break;

                            case 'productEcoRebatesFlag':
                                infoObj[key] =
                                    defaultLot &&
                                    defaultLot.items &&
                                    defaultLot.items[0] &&
                                    defaultLot.items[0].rebatesAvailable
                                        ? 'yes'
                                        : 'no';
                                break;

                            default:
                                break;
                        }
                    });
                    analyticsObj.push(tempObj);
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.log(e);
                }
            };

            const prepareGridData = () => {
                try {
                    sourceData.forEach((sections, level) => {
                        const gridSection = sections.defaultLotSpecification.data;
                        prepareAnalyticsObj(sections);
                        prepareAboveGridData(sections);
                        gridSection.forEach((category) => {
                            if (!gridData[category.name]) {
                                gridData[category.name] = {};
                            }
                            category.attributes.forEach((attribute) => {
                                if (!gridData[category.name][attribute.name]) {
                                    // Insert data into object if key does not exist.
                                    gridData[category.name][attribute.name] = [attribute.value];
                                } else {
                                    // Insert data into object if a Key already exists.
                                    gridData[category.name][attribute.name][level] =
                                        attribute.value;
                                }
                            });
                            // Re-concile for missing keys.
                            reconcileCategory(
                                gridKeys[category.name],
                                gridData[category.name],
                                level
                            );
                        });
                    });
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.log(e);
                }
            };

            const preparePIDRow = () => {
                sourceData.forEach((sections) => {
                    ppIds.push(sections.id);
                });
            };

            const prepareCategory = () => {
                if (sourceData.length) {
                    for (let i = 0; i < sourceData.length; i += 1) {
                        const section = sourceData[i];
                        if (section.category && section.category.name) {
                            productsCategory.categoryName = section.category.name;
                            break;
                        }
                    }
                    productsCategory.items = sourceData.length;
                }
            };

            if (action.payload.data) {
                prepareGridKeys();
                preparePIDRow();
                prepareGridData();
                prepareCategory();
            }

            return action.payload && action.payload.data
                ? { gridData, aboveGridData, ppIds, analyticsObj, productsCategory }
                : {};

        default:
            return state;
    }
}
